// Importing necessary dependencies and styles
import React, { useCallback, useEffect, useState } from "react";
import "./index.css";

// Importing the ImageModal component
import ImageModal from "../cropper/ImageModal";

// Common Input for image component
const ImageInput = ({ name, onChange, fileData, OriginalImage, setAddImgesModal, addImageModal }) => {
  // State variables for managing image, modal state, height, and width
  const [image, setImage] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [height, setHeight] = useState(null);
  const [width, setWidth] = useState(null);

  // Handler for updating the input file
  const onChangeHandler = useCallback((file) => {
    onChange({
      [name]: {
        data: fileData,
        src: file,
      },
    });
  }, [onChange, name, fileData]);

 // useEffect to handle the case when addImageModal and fileData change
 useEffect(() => {
  // Handler for processing the selected file
  const handleFile = (e) => {
    if (e) {
      // Extracting file information
      const file = e;
      var url = URL.createObjectURL(file);
      var img = new Image();

      // Setting up an image object to get width and height
      img.src = url;
      img.onload = function () {
        setWidth(this.width);
        setHeight(this.height);
      };

      // Setting a maximum allowed file size
      const maxAllowedSize = 10 * 1024 * 1024;
      if (file.size > maxAllowedSize) {
        // Handle case where file size exceeds the limit
      } else {
        // Setting the image and opening the modal
        setImage(file);
        setModalIsOpen(true);
      }
    }
    // Closing the image modal
    setAddImgesModal(false);
  };

  if (addImageModal && fileData) {
    handleFile(fileData);
  }
}, [fileData, addImageModal, setAddImgesModal, onChangeHandler]);

  return (
    <>
      {/* Rendering the ImageModal component */}
      <ImageModal
        modalIsOpen={modalIsOpen}
        closeModal={() => {
          setModalIsOpen((prevState) => !prevState);
        }}
        image={image}
        onCropImage={(croppedImg) => onChangeHandler(croppedImg)}
        ratio={height / width <= 0.5 ? true : false}
        OriginalImage={OriginalImage}
        setAddImgesModal={addImageModal}
      />
    </>
  );
};

// Exporting the ImageInput component
export default ImageInput;
